import React from 'react'
import '../../css/AiToolPaymentErrorBanner.css'

const AiToolPaymentErrorBanner = ({ message, onDismiss }) => {
  if (!message) return null

  return (
    <div className="ai-tool-payment-error" role="alert">
      <div className="ai-tool-payment-error__icon" aria-hidden="true">
        !
      </div>
      <div className="ai-tool-payment-error__content">
        <div className="ai-tool-payment-error__title">Payment failed</div>
        <p className="ai-tool-payment-error__message">{message}</p>
      </div>
      {onDismiss ? (
        <button
          type="button"
          className="ai-tool-payment-error__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss payment error"
        >
          ×
        </button>
      ) : null}
    </div>
  )
}

export default AiToolPaymentErrorBanner
